import * as React from "react";
import { forwardRef } from "react";
const SvgList = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.33333 11.9999H13M6.33333 7.33325H13M6.33333 2.66659H13M1 2.66659L1.66667 3.33325L3.66667 1.33325M1 7.33325L1.66667 7.99992L3.66667 5.99992M1 11.9999L1.66667 12.6666L3.66667 10.6666", stroke: "#7F8493", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
